import { FC } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { QuoteUser } from 'src/redux/types/quoteSlice';
import { Box, Typography, Button } from '@mui/material';
import { UsersListProps } from './types';
import User from '../User';

const UsersList: FC<UsersListProps> = ({ name, label }) => {
	const { control } = useFormContext();

	const { fields, append, remove } = useFieldArray({ control, name });

	const users = fields as never as QuoteUser[];

	const handleAddUser = () => append({ givenNames: '', lastNames: '', email: '', phone: null });

	return (
		<Box>
			<Typography variant='subtitle1'>{label}</Typography>
			<Box display='flex' flexDirection='column' gap='20px' mt='15px'>
				{users.map((u: QuoteUser, index) => (
					<User
						key={u.email}
						name={name}
						index={index}
						isLast={index + 1 === users.length}
						handleDelete={() => remove(index)}
					/>
				))}
			</Box>
			<Box>
				<Button onClick={handleAddUser}>Add new user</Button>
			</Box>
		</Box>
	);
};

export default UsersList;
